import { api } from './api';

export const attendanceService = {
  getStudentAttendance: (classId, sectionId, date) => {
    return api.get('/attendance/student-attendance', {
      params: { classId, sectionId, date }
    });
  },

  markAttendance: (attendanceData) => {
    return api.post('/attendance/mark-attendance', attendanceData);
  },

  setHoliday: (holidayData) => {
    return api.post('/attendance/set-holiday', holidayData);
  },

  getHolidays: (month, year) => {
    return api.get('/attendance/get-holidays', {
      params: { month, year }
    });
  }
};
